import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../strings";
import { Patient } from "../../system/AppState/AppPatientsState";
import { translate } from "../../translate";
import { List } from "../../utils/List";
import ScreenPlaceholder from "../ScreenPlaceholder";
import PatientCard from "./components/PatientCard";

interface Props {
  patients: List<Patient>;
  onClickPatient: (patient: Patient) => void;
  onRequestAvailableVisits: () => void;
  isSearch: boolean;
}

const PatientsScreen = (props: Props) => {
  if (props.patients.length() === 0 && !props.isSearch) {
    return (
      <ScreenPlaceholder
        headline={translate(STRINGS.YOU_DONT_HAVE_ANY_PATIENTS_YET)}
        subheadline={translate(STRINGS.FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE)}
        buttonText={translate(STRINGS.LETS_FIND_YOUR_FIRST_PATIENT)}
        onClick={props.onRequestAvailableVisits}
        illustration="NoCompletedInservices"
      />
    );
  }

  return (
    <>
      <PatientsContainer>
        {props.patients.map((patient) => (
          <PatientCard
            key={patient.id.toString()}
            patient={patient}
            onClick={props.onClickPatient}
          />
        ))}
      </PatientsContainer>
    </>
  );
};

const animation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
`;

const PatientsContainer = styled.div`
  animation: ${animation} 0.3s ease-in-out;
  padding: 16px;
  .PatientCard + .PatientCard {
    margin-top: 16px;
  }
`;

export default React.memo(PatientsScreen);
